<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">
          {{ $t('product.products') }}
        </span>
        <h3 class="page-title">
          {{ $t('productCategories.addCategory') }}
        </h3>
      </d-col>
      <d-col
        col
        sm="6"
        class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/kategorie-produktow')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          {{ $t('ui.backToList') }}
        </d-button>
        <d-button
          theme="success"
          @click.prevent="validateForm">
          <i class="material-icons">add</i>
          {{ $t('productCategories.addCategory') }}
        </d-button>
      </d-col>
    </d-row>

    <!-- Form -->
    <d-form>
      <validation-observer ref="category-new-form" tag="form">
        <d-card class="mb-5">
          <d-tabs card v-if="!loadError">
            <!-- Dane ogólne -->
            <d-tab
              :title="$t('ui.generalInfo')"
              active>
              <h4 class="mb-3 pb-3 border-bottom">
                {{ $t('ui.generalInfo') }}
              </h4>

              <div class="form-group">
                <label>
                  {{ $t('productCategories.name') }}:
                </label>

                <validation-provider
                  rules="required"
                  name="name"
                  v-slot="{ errors }">
                    <d-input
                      :state="errors.length ? 'invalid' : null"
                      v-model="name" />
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                </validation-provider>
              </div>

              <div class="form-group">
                <label>
                  {{ $t('productCategories.parentCategory') }}:
                </label>

                <div :class="{
                  'form-control': true,
                  'is-select': true
                }">
                  <v-select
                    :options="flatCategories"
                    v-model="parent_id"
                    :reduce="category => category.id"
                    :placeholder="$t('productCategories.noParentCategory')"
                    label="name"
                    :clearable="true">
                    <template slot="no-options">
                      {{ $t('productCategories.noCategoriesToDisplay') }}&hellip;
                    </template>
                    <template slot="option" slot-scope="option">
                      <div class="d-center">
                        {{ option.name }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      <div class="selected d-center">
                        {{ option.name }}
                      </div>
                    </template>
                  </v-select>
                </div>
              </div>
            </d-tab>

            <d-tab
              :disabled="true"
              :title="$t('productCategories.translations')">
            </d-tab>
          </d-tabs>

          <div v-if="!allDataLoaded" class="pb-3 pt-3 text-center overlay-loading">
            {{ $t('ui.dataLoading') }}&hellip;
          </div>

          <d-alert
            v-if="loadError"
            show
            theme="warning">
            {{ $t('ui.dataLoadingFailed') }} <a href="javascript:window.location.reload();" class="alert-link">{{ $t('ui.refreshPage') }}</a> {{ $t('ui.toTryAgain') }}
          </d-alert>
        </d-card>
      </validation-observer>
    </d-form>
  </d-container>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'category-new',
  computed: {
    allDataLoaded () {
      return this.loadedCategories;
    },
    flatCategories() {
      let result = [];
      let stack = this.categories.map(category => ({ ...category, prefix: '' }));

      while (stack.length > 0) {
        let current = stack.shift();

        result.push({
          id: current.id,
          name: current.prefix + current.name
        });

        if (current.children && current.children.length > 0) {
          stack = [
            ...current.children.map(child => ({ ...child, prefix: current.prefix + '- ' })),
            ...stack
          ];
        }
      }

      return result;
    }
  },
  data() {
    return {
      name: '',
      parent_id: null,
      loadError: false,
      categories: [],
      loadedCategories: false
    };
  },
  mounted () {
    this.loadCategories();
  },
  methods: {
    validateForm () {
      FormUtils.validate(this.$refs['category-new-form'], this.submitForm);
    },
    submitForm () {
      let formDataToSend = {
        name: this.name,
        parent_id: this.parent_id === null ? 0 : this.parent_id
      };

      FormUtils.submit({
        $http: this.$http,
        endpoint: '/categories/store',
        formData: formDataToSend,
        successTitle: this.$t('productCategories.addCategorySuccessTitle'),
        successText: this.$t('productCategories.addCategorySuccessText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('productCategories.addCategoryErrorText'),
        successAction: (responseData) => {
          this.$router.push('/kategorie-produktow/edycja/' + responseData.id);
        }
      });
    },
    loadCategories () {
      FormUtils.loadAdditionalData(this, {
        method: 'get',
        endpoint: '/categories/items',
        loadedKey: 'loadedCategories',
        outputKey: 'categories',
        errorKey: 'loadError'
      });
    }
  }
};
</script>
